module.exports = __webpack_public_path__ + "media/volvo/assets/images/volvo_v90@2x-7ae74a6b72a764f92a84779e9ab457c2.png";